import './TitleBox.css';
import { useScrollReveal } from '../../../useScrollReveal';
import GrainOverlay from '../../../GrainOverlay';

const TitleBox = (props) => {
    const { ref, style } = useScrollReveal('clipRevealDown');

    return (
        <div className={`TitleBox grain-light ${props.blue ? 'blue' : ''}`} ref={ref} style={style}>
            <GrainOverlay intensity={0.06} />
            <div className="TitleBox-inner">
                {props.meta && (
                    <div className="TitleBox-meta">{props.meta}</div>
                )}
                <h1 dangerouslySetInnerHTML={{__html: props.title}}/>
                <div className="description" dangerouslySetInnerHTML={{__html: props.description}}/>
            </div>
        </div>
    );
};

export default TitleBox;
